import { SafeAny } from '@core/types/safe-any.type';

export function formatUrl(template: string, values: { [key: string]: SafeAny }): string {
  return template.replace(/{([^{}]*)}/g, (match, key) => {
    const value = values[key];
    return value !== undefined ? value : match;
  });
}

export function getFullRelativeUrl(): string {
  const fullUrl = window.location.href;
  const baseUrl = window.location.origin;

  // This removes the domain part and keeps only the path + query + hash
  const fullReturnUrl = fullUrl.substring(baseUrl.length);

  return fullReturnUrl || '/';
}
